<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-7
                class="text-left fw-500 d-flex align-items-center justify-content-between">
                    <div>
                        <span class="box-numbering">07</span>
                        <span>Your Rights</span>    
                    </div>
                    <span 
                        class="toggle-icon" 
                        :class="{ active: isOpen }"
                    >
                        <span class="plus">+</span>
                        <span class="cross">×</span>
                    </span> 
                </b-button>
                
            </b-card-header>
            <b-collapse 
            id="privacy-section-7" 
            visible 
            accordion="my-accordion" 
            role="tabpanel"
            @show="isOpen = true"
            @hide="isOpen = false">
                <b-card-body>
                    <p class="text-justify">Your Rights You have the right to:
                        <ol>
                            <li>Access and request a copy of the personal information we hold about you.</li>
                            <li>Request correction or deletion of inaccurate or outdated information.</li>
                            <li>Object to or restrict the processing of your personal information.</li>
                            <li>Withdraw consent to the use of your data (where consent is the legal basis for processing).</li>
                            <li>To exercise these rights, please contact us at <a href="mailto:support@oripay.us">support@oripay.us</a>.</li>
                        </ol>
                    </p>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-7',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        isOpen: true
        };
    },
    props:['companyName']
};
</script>